// extracted by mini-css-extract-plugin
export var container = "_ry-0";
export var table = "_ry-2";
export var tableWrapper = "_ry-1";